import { render, staticRenderFns } from "./Bimini_aperitifs.vue?vue&type=template&id=36785fc0&scoped=true"
import script from "./Bimini_aperitifs.vue?vue&type=script&lang=ts"
export * from "./Bimini_aperitifs.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_aperitifs.vue?vue&type=style&index=0&id=36785fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36785fc0",
  null
  
)

export default component.exports